// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_o7-5";
export var filledCircle = "_o7-4";
export var historyEntry = "_o7-3";
export var messageSideLeft = "_o7-1";
export var messageSideRight = "_o7-2";
export var orderTrackingCarouselWrapper = "_o7-6";
export var orderTrackingInfoContainer = "_o7-0";